module.exports = __webpack_public_path__ + "static/media/automation.4ca2f71f.svg";